

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import UserApi from "../../../../services/UserApi.jsx";
import { separatorNumber, useGlobalFunc } from "../../../../global/constants.js";
import { Pagination } from "@mui/material";
import { isValidPassword } from "../../../../global/regex.js";






// import homeshadowImg from '../../../assets/homeshadow.png'
// import homescrollImg from '../../../assets/homescroll.png'

// import homepic1Img from '../../../assets/homepic1.png'
// import homepic2Img from '../../../assets/homepic2.png'


const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);


    const { setLoading, successToast, errorToast } = useGlobalFunc()


    const [oldPw, setOldPw] = useState('')
    const [pw, setPw] = useState('')
    const [againPw, setAgainPw] = useState('')

    async function updatePw(e) {
        e.preventDefault();

        if (pw != againPw) {
            errorToast('新密碼和重複新密碼必須一致')
            return
        }

        if (pw.length < 8) {
            errorToast('新密碼必須至少8個字符長')
            return
        }

        setLoading(true)
        try {
            let res = await UserApi.updateMe({ oldPassword: oldPw, accountPw: pw })
            console.log(res.data.data)

            setOldPw('')
            setPw('')
            setAgainPw('')

            successToast('更改成功')


        }
        catch (errors) {
            if (errors?.response?.data?.message == 'The old password is incorrect') {
                errorToast('舊密碼錯誤')
            }
            else {
                errorToast(errors?.response?.data?.message || errors.toString())
            }
        }
        finally {
            setLoading(false)
        }

    }

    useEffect(() => {



    }, []);

    return <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
        <div className="text-lg font-bold mb-4">{t('memberCenterType.changepw')}</div>


        <form onSubmit={(e) => updatePw(e)}>
            <div className="grid grid-cols-1 gap-4">
                <div className="">
                    <div className="flex justify-between text-sm font-bold mb-2">
                        <p className="">舊密碼</p>
                    </div>
                    <input type="password" required className={`input w-full `} value={oldPw} onChange={e => setOldPw(e.target.value)} />
                </div>
                <div className="">
                    <div className="flex justify-between text-sm font-bold mb-2">
                        <p className="">新密碼</p>
                    </div>
                    <input type="password" required className={`input w-full `} value={pw} onChange={e => setPw(e.target.value)} />
                    <p className="mt-2 text-xs to-black7">新密碼必須至少8個字符長</p>
                </div>
                <div className="">
                    <div className="flex justify-between text-sm font-bold mb-2">
                        <p className="">重複新密碼</p>
                    </div>
                    <input type="password" required className={`input w-full `} value={againPw} onChange={e => setAgainPw(e.target.value)} />
                </div>

                <div className="flex justify-center mt-4">
                    <button type="submit" className="btn1 !min-w-[120px]">
                        確定更改
                    </button>
                </div>
            </div>
        </form>

    </div>

}

export default Home